import PaymentCard from './components/PaymentCard'

export default PaymentCard



// WEBPACK FOOTER //
// ./index.js